/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис ключей
 */

/**
 * Сервис ключей
 */
export class RfidServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения ключа.
   * Метод доступен для: admin, service, ltp_first, owner, employee
   */
  GetRfid = (req: GetRfidRequestDto, init?: RequestInit): Promise<GetRfidResponseDto> => {
    return fm.request<GetRfidRequestDto, GetRfidResponseDto>(`${this.host}/access_control/api/v1/rfid/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка ключей.
   * Метод доступен для: admin, service, ltp_first, owner, employee
   */
  GetRfidList = (req?: GetRfidListRequestDto, init?: RequestInit): Promise<GetRfidListResponseDto[]> => {
    return fm.list<GetRfidListRequestDto, GetRfidListResponseDto>(`${this.host}/access_control/api/v1/rfid/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества ключей.
   * Метод доступен для: admin, service, ltp_first, owner, employee
   */
  GetRfidCount = (req?: GetRfidCountRequestDto, init?: RequestInit): Promise<GetRfidCountResponseDto> => {
    return fm.request<GetRfidCountRequestDto, GetRfidCountResponseDto>(`${this.host}/access_control/api/v1/rfid/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания ключа.
   * Метод доступен для: admin, service, ltp_first, owner, employee
   */
  PostRfid = (req: PostRfidRequestDto, init?: RequestInit): Promise<PostRfidResponseDto> => {
    return fm.request<PostRfidRequestDto, PostRfidResponseDto>(`${this.host}/access_control/api/v1/rfid`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления ключа.
   * Метод доступен для: admin, service, ltp_first, owner, employee
   */
  DeleteRfid = (req: DeleteRfidRequestDto, init?: RequestInit): Promise<DeleteRfidResponseDto> => {
    return fm.request<DeleteRfidRequestDto, DeleteRfidResponseDto>(`${this.host}/access_control/api/v1/rfid/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип владельца ключа
 */
export enum RfidHolderType {
  /**
   * Значение не указано
   */
  HOLDER_TYPE_UNKNOWN = "HOLDER_TYPE_UNKNOWN",
  /**
   * Жилец
   */
  MASTER = "MASTER",
  /**
   * Сотрудник УК
   */
  COMPANY = "COMPANY",
  /**
   * Ключ сотрудника ГАП
   */
  EXTERNAL_SELLER = "EXTERNAL_SELLER",
  /**
   * Системный ключ
   */
  SYSTEM = "SYSTEM",
}
/**
 * Тип владельца ключа
 */
export type RfidHolderTypeResponseEnum = keyof typeof RfidHolderType
/**
 * Тип владельца ключа
 */
export type RfidHolderTypeRequestEnum = Exclude<RfidHolderTypeResponseEnum, "HOLDER_TYPE_UNKNOWN">;

/**
 * Тип оплаты
 */
export enum RfidPayType {
  /**
   * Значение не указано
   */
  PAY_TYPE_UNKNOWN = "PAY_TYPE_UNKNOWN",
  /**
   * Платный
   */
  PAID = "PAID",
  /**
   * Бесплатный
   */
  FREE = "FREE",
}
/**
 * Тип оплаты
 */
export type RfidPayTypeResponseEnum = keyof typeof RfidPayType
/**
 * Тип оплаты
 */
export type RfidPayTypeRequestEnum = Exclude<RfidPayTypeResponseEnum, "PAY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum RfidPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type RfidPagingDirectionTypeResponseEnum = keyof typeof RfidPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type RfidPagingDirectionTypeRequestEnum = Exclude<RfidPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum RfidPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По времени создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По времени изменения
   */
  CHANGED_AT = "CHANGED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type RfidPagingOrderByTypeResponseEnum = keyof typeof RfidPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type RfidPagingOrderByTypeRequestEnum = Exclude<RfidPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления ключа
 */
export type DeleteRfidRequestDto = {
  /**
   * Идентификатор ключа.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * Флаг принудительного удаления ключа.
   * При принудительном удалении не гарантируется удаление ключа со всех физических устройств
   */
  isForceDelete?: boolean
}
/**
 * Ответ на запрос удаления ключа
 */
export type DeleteRfidResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteRfidResponseErrorDto
}>
/**
 * Ошибка запроса на удаление ключа
 */
export type DeleteRfidResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на удаление ключа
 */
export type DeleteRfidResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества ключей
 */
export type GetRfidCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: RfidFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества ключей
 */
export type GetRfidCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetRfidCountResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetRfidCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetRfidCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка ключей
 */
export type GetRfidListRequestDto = {
  /**
   * Фильтр
   */
  filter?: RfidFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: RfidPagingRequestDto
}>
/**
 * Ответ на запрос получения списка ключей
 */
export type GetRfidListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ключ
   */
  readonly data: RfidResponseDto
  /**
   * Ошибка
   */
  readonly error: GetRfidListResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetRfidListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetRfidListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения ключа
 */
export type GetRfidRequestDto = {
  /**
   * Идентификатор ключа.
   * # Диапазон: 0..2147483647
   */
  id: number
}
/**
 * Ответ на запрос получения ключа
 */
export type GetRfidResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ключ
   */
  readonly data: RfidResponseDto
  /**
   * Ошибка
   */
  readonly error: GetRfidResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetRfidResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetRfidResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос создания ключа
 */
export type PostRfidRequestDto = {
  /**
   * Ключ
   */
  data: RfidRequestDto
}
/**
 * Ответ на запрос создания ключа
 */
export type PostRfidResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ключ
   */
  readonly data: RfidResponseDto
  /**
   * Ошибка
   */
  readonly error: PostRfidResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostRfidResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: RfidSavingErrorRequestDto
}>
/**
 * Ошибка
 */
export type PostRfidResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: RfidSavingErrorResponseDto
}>
/**
 * Ключ.
 * # Описание модели
 */
export type RfidRequestDto = {
  /**
   * Идентификатор ключа.
   * # Диапазон: 0..2147483647
   */
  id?: number
  /**
   * Идентификатор пользователя
   */
  userId?: number | null
  /**
   * Системное описание.
   * Обычно оставляет УК/Админ, пользователь его не видет
   */
  description?: string | null
  /**
   * Идентификатор компании
   */
  companyId?: number | null
  /**
   * Идентификатор создателя
   */
  creatorId?: number | null
  /**
   * Код ключа (UID).
   * Уникальное значение.
   * # Паттерн: /^[0-9a-fA-F]{1,14}$/
   */
  key: string
  /**
   * Тип оплаты
   */
  payType: RfidPayTypeRequestEnum
  /**
   * Тип владельца ключа
   */
  holderType: RfidHolderTypeRequestEnum
  /**
   * Дата обновления.
   * # Тип: DateTime?
   */
  changedAt?: string | null
  /**
   * ОРПОН дома.
   * # Диапазон: 1..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
}
/**
 * Ключ.
 * # Описание модели
 */
export type RfidResponseDto = {
  /**
   * Идентификатор ключа.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * Идентификатор пользователя
   */
  userId: number | null
  /**
   * Системное описание.
   * Обычно оставляет УК/Админ, пользователь его не видет
   */
  description: string | null
  /**
   * Идентификатор компании
   */
  companyId: number | null
  /**
   * Идентификатор создателя
   */
  creatorId: number | null
  /**
   * Код ключа (UID).
   * Уникальное значение.
   * # Паттерн: /^[0-9a-fA-F]{1,14}$/
   */
  key: string
  /**
   * Тип оплаты
   */
  payType: RfidPayTypeResponseEnum
  /**
   * Тип владельца ключа
   */
  holderType: RfidHolderTypeResponseEnum
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата обновления.
   * # Тип: DateTime?
   */
  changedAt: string
  /**
   * ОРПОН дома.
   * # Диапазон: 1..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
}
/**
 * Ошибка сохранения ключа.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type RfidSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: RfidSavingErrorConflictRequestDto
  /**
   * Данный ключ уже существует
   */
  readonly keyExist: RfidSavingErrorKeyExistRequestDto
  /**
   * Нельзя изменить код ключа
   */
  readonly keyCodeCannotBeChanged: RfidSavingErrorKeyCodeCannotBeChangedRequestDto
  /**
   * Превышено максимально допустимое количество ключей (16) для квартиры
   */
  readonly exceededQuantityOfKeysForRoom: RfidSavingErrorExceededQuantityOfKeysForRoomRequestDto
  /**
   * Ключ используется на другой квартире
   */
  readonly keyIsUsed: RfidSavingErrorKeyIsUsedRequestDto
  /**
   * Нельзя создавать / изменять ключ с переданным типом владельца
   */
  readonly holderTypeForbidden: RfidSavingErrorHolderTypeForbiddenRequestDto
}>
/**
 * Ошибка сохранения ключа.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type RfidSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: RfidSavingErrorConflictResponseDto
  /**
   * Данный ключ уже существует
   */
  readonly keyExist: RfidSavingErrorKeyExistResponseDto
  /**
   * Нельзя изменить код ключа
   */
  readonly keyCodeCannotBeChanged: RfidSavingErrorKeyCodeCannotBeChangedResponseDto
  /**
   * Превышено максимально допустимое количество ключей (16) для квартиры
   */
  readonly exceededQuantityOfKeysForRoom: RfidSavingErrorExceededQuantityOfKeysForRoomResponseDto
  /**
   * Ключ используется на другой квартире
   */
  readonly keyIsUsed: RfidSavingErrorKeyIsUsedResponseDto
  /**
   * Нельзя создавать / изменять ключ с переданным типом владельца
   */
  readonly holderTypeForbidden: RfidSavingErrorHolderTypeForbiddenResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type RfidSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type RfidSavingErrorConflictResponseDto = {
}
/**
 * Превышено максимально допустимое количество ключей (16) для квартиры
 */
export type RfidSavingErrorExceededQuantityOfKeysForRoomRequestDto = {
}
/**
 * Превышено максимально допустимое количество ключей (16) для квартиры
 */
export type RfidSavingErrorExceededQuantityOfKeysForRoomResponseDto = {
}
/**
 * Нельзя создавать / изменять ключ с переданным типом владельца.
 * Доступные типы владельца:
 * - Жилец (мастер)
 */
export type RfidSavingErrorHolderTypeForbiddenRequestDto = {
}
/**
 * Нельзя создавать / изменять ключ с переданным типом владельца.
 * Доступные типы владельца:
 * - Жилец (мастер)
 */
export type RfidSavingErrorHolderTypeForbiddenResponseDto = {
}
/**
 * Нельзя изменить код ключа.
 * Причины:
 * - При изменении ключа нельзя менять поле key (код ключа)
 */
export type RfidSavingErrorKeyCodeCannotBeChangedRequestDto = {
}
/**
 * Нельзя изменить код ключа.
 * Причины:
 * - При изменении ключа нельзя менять поле key (код ключа)
 */
export type RfidSavingErrorKeyCodeCannotBeChangedResponseDto = {
}
/**
 * Данный ключ уже существует.
 * Причины:
 * - При попытке создания ключа в системе уже существует ключ с таким же кодом
 */
export type RfidSavingErrorKeyExistRequestDto = {
}
/**
 * Данный ключ уже существует.
 * Причины:
 * - При попытке создания ключа в системе уже существует ключ с таким же кодом
 */
export type RfidSavingErrorKeyExistResponseDto = {
}
/**
 * Ключ используется на другой квартире
 */
export type RfidSavingErrorKeyIsUsedRequestDto = {
}
/**
 * Ключ используется на другой квартире
 */
export type RfidSavingErrorKeyIsUsedResponseDto = {
}
/**
 * Фильтр по ключам
 */
export type RfidFilterRequestDto = {
  /**
   * По типам владельца
   */
  holderTypes?: RfidHolderTypeResponseEnum[]
  /**
   * По типам оплаты
   */
  payTypes?: RfidPayTypeResponseEnum[]
  /**
   * По ОРПОНам
   */
  orpons?: string[]
  /**
   * По номерам квартир
   */
  roomNumbers?: string[]
  /**
   * По идентификаторам пользователей
   */
  userIds?: number[]
  /**
   * По идентификаторам компаний
   */
  companyIds?: number[]
  /**
   * По кодам ключа
   */
  keys?: string[]
}
/**
 * Фильтр по ключам
 */
export type RfidFilterResponseDto = {
  /**
   * По типам владельца
   */
  holderTypes: RfidHolderTypeResponseEnum[]
  /**
   * По типам оплаты
   */
  payTypes: RfidPayTypeResponseEnum[]
  /**
   * По ОРПОНам
   */
  orpons: string[]
  /**
   * По номерам квартир
   */
  roomNumbers: string[]
  /**
   * По идентификаторам пользователей
   */
  userIds: number[]
  /**
   * По идентификаторам компаний
   */
  companyIds: number[]
  /**
   * По кодам ключа
   */
  keys: string[]
}
/**
 * Постраничный вывод
 */
export type RfidPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: RfidPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: RfidPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type RfidPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: RfidPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: RfidPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления ключа
   */
  "DeleteRfidRequest": {
    "kind": "class",
    "text": "Запрос удаления ключа",
    "fields": {
      /**
       * Идентификатор ключа.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор ключа.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Флаг принудительного удаления ключа.
       * При принудительном удалении не гарантируется удаление ключа со всех физических устройств
       */
      "isForceDelete": {
        "type": "bool",
        "text": "Флаг принудительного удаления ключа.\nПри принудительном удалении не гарантируется удаление ключа со всех физических устройств",
      },
    },
  },
  /**
   * Ответ на запрос удаления ключа
   */
  "DeleteRfidResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления ключа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteRfidResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на удаление ключа
   */
  "DeleteRfidResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на удаление ключа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества ключей
   */
  "GetRfidCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества ключей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RfidFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества ключей
   */
  "GetRfidCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества ключей",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRfidCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetRfidCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка ключей
   */
  "GetRfidListRequest": {
    "kind": "class",
    "text": "Запрос получения списка ключей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RfidFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "RfidPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка ключей
   */
  "GetRfidListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка ключей",
    "fields": {
      /**
       * Ключ
       */
      "data": {
        "type": "Rfid",
        "text": "Ключ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRfidListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetRfidListResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения ключа
   */
  "GetRfidRequest": {
    "kind": "class",
    "text": "Запрос получения ключа",
    "fields": {
      /**
       * Идентификатор ключа.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор ключа.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос получения ключа
   */
  "GetRfidResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения ключа",
    "fields": {
      /**
       * Ключ
       */
      "data": {
        "type": "Rfid",
        "text": "Ключ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRfidResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetRfidResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос создания ключа
   */
  "PostRfidRequest": {
    "kind": "class",
    "text": "Запрос создания ключа",
    "fields": {
      /**
       * Ключ
       */
      "data": {
        "type": "Rfid",
        "text": "Ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос создания ключа
   */
  "PostRfidResponse": {
    "kind": "class",
    "text": "Ответ на запрос создания ключа",
    "fields": {
      /**
       * Ключ
       */
      "data": {
        "type": "Rfid",
        "text": "Ключ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostRfidResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostRfidResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Rfid.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Ключ.
   * # Описание модели
   */
  "Rfid": {
    "kind": "class",
    "text": "Ключ.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор ключа.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор ключа.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор пользователя",
      },
      /**
       * Системное описание.
       * Обычно оставляет УК/Админ, пользователь его не видет
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Системное описание.\nОбычно оставляет УК/Админ, пользователь его не видет",
      },
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор компании",
      },
      /**
       * Идентификатор создателя
       */
      "creatorId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор создателя",
      },
      /**
       * Код ключа (UID).
       * Уникальное значение.
       * # Паттерн: /^[0-9a-fA-F]{1,14}$/
       */
      "key": {
        "type": "string",
        "text": "Код ключа (UID).\nУникальное значение.\n# Паттерн: /^[0-9a-fA-F]{1,14}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^[0-9a-fA-F]{1,14}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[0-9a-fA-F]{1,14}$/"
          }
        }
      },
      /**
       * Тип оплаты
       */
      "payType": {
        "type": "Rfid.PayType",
        "text": "Тип оплаты",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип владельца ключа
       */
      "holderType": {
        "type": "Rfid.HolderType",
        "text": "Тип владельца ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата обновления.
       * # Тип: DateTime?
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата обновления.\n# Тип: DateTime?",
      },
      /**
       * ОРПОН дома.
       * # Диапазон: 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома.\n# Диапазон: 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 9223372036854775807,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9223372036854775807"
          },
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..4
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..4",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения ключа.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "Rfid.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения ключа.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "Rfid.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Данный ключ уже существует
       */
      "keyExist": {
        "type": "Rfid.SavingError.KeyExist",
        "text": "Данный ключ уже существует",
      },
      /**
       * Нельзя изменить код ключа
       */
      "keyCodeCannotBeChanged": {
        "type": "Rfid.SavingError.KeyCodeCannotBeChanged",
        "text": "Нельзя изменить код ключа",
      },
      /**
       * Превышено максимально допустимое количество ключей (16) для квартиры
       */
      "exceededQuantityOfKeysForRoom": {
        "type": "Rfid.SavingError.ExceededQuantityOfKeysForRoom",
        "text": "Превышено максимально допустимое количество ключей (16) для квартиры",
      },
      /**
       * Ключ используется на другой квартире
       */
      "keyIsUsed": {
        "type": "Rfid.SavingError.KeyIsUsed",
        "text": "Ключ используется на другой квартире",
      },
      /**
       * Нельзя создавать / изменять ключ с переданным типом владельца
       */
      "holderTypeForbidden": {
        "type": "Rfid.SavingError.HolderTypeForbidden",
        "text": "Нельзя создавать / изменять ключ с переданным типом владельца",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "Rfid.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Превышено максимально допустимое количество ключей (16) для квартиры
   */
  "Rfid.SavingError.ExceededQuantityOfKeysForRoom": {
    "kind": "class",
    "text": "Превышено максимально допустимое количество ключей (16) для квартиры",
  },
  /**
   * Нельзя создавать / изменять ключ с переданным типом владельца.
   * Доступные типы владельца:
   * - Жилец (мастер)
   */
  "Rfid.SavingError.HolderTypeForbidden": {
    "kind": "class",
    "text": "Нельзя создавать / изменять ключ с переданным типом владельца.\nДоступные типы владельца:\n- Жилец (мастер)",
  },
  /**
   * Нельзя изменить код ключа.
   * Причины:
   * - При изменении ключа нельзя менять поле key (код ключа)
   */
  "Rfid.SavingError.KeyCodeCannotBeChanged": {
    "kind": "class",
    "text": "Нельзя изменить код ключа.\nПричины:\n- При изменении ключа нельзя менять поле key (код ключа)",
  },
  /**
   * Данный ключ уже существует.
   * Причины:
   * - При попытке создания ключа в системе уже существует ключ с таким же кодом
   */
  "Rfid.SavingError.KeyExist": {
    "kind": "class",
    "text": "Данный ключ уже существует.\nПричины:\n- При попытке создания ключа в системе уже существует ключ с таким же кодом",
  },
  /**
   * Ключ используется на другой квартире
   */
  "Rfid.SavingError.KeyIsUsed": {
    "kind": "class",
    "text": "Ключ используется на другой квартире",
  },
  /**
   * Фильтр по ключам
   */
  "RfidFilter": {
    "kind": "class",
    "text": "Фильтр по ключам",
    "fields": {
      /**
       * По типам владельца
       */
      "holderTypes": {
        "type": "Rfid.HolderType",
        "text": "По типам владельца",
      },
      /**
       * По типам оплаты
       */
      "payTypes": {
        "type": "Rfid.PayType",
        "text": "По типам оплаты",
      },
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
      /**
       * По номерам квартир
       */
      "roomNumbers": {
        "type": "string",
        "text": "По номерам квартир",
      },
      /**
       * По идентификаторам пользователей
       */
      "userIds": {
        "type": "int32",
        "text": "По идентификаторам пользователей",
      },
      /**
       * По идентификаторам компаний
       */
      "companyIds": {
        "type": "int32",
        "text": "По идентификаторам компаний",
      },
      /**
       * По кодам ключа
       */
      "keys": {
        "type": "string",
        "text": "По кодам ключа",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "RfidPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "RfidPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "RfidPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Тип владельца ключа
   */
  "Rfid.HolderType": {
    "kind": "enum",
    "text": "Тип владельца ключа",
    "values": {
      /**
       * Значение не указано
       */
      "HOLDER_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Жилец
       */
      "MASTER": {
        "i": 1,
        "text": "Жилец",
      },
      /**
       * Сотрудник УК
       */
      "COMPANY": {
        "i": 2,
        "text": "Сотрудник УК",
      },
      /**
       * Ключ сотрудника ГАП
       */
      "EXTERNAL_SELLER": {
        "i": 3,
        "text": "Ключ сотрудника ГАП",
      },
      /**
       * Системный ключ
       */
      "SYSTEM": {
        "i": 4,
        "text": "Системный ключ",
      },
    },
  },
  /**
   * Тип оплаты
   */
  "Rfid.PayType": {
    "kind": "enum",
    "text": "Тип оплаты",
    "values": {
      /**
       * Значение не указано
       */
      "PAY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Платный
       */
      "PAID": {
        "i": 1,
        "text": "Платный",
      },
      /**
       * Бесплатный
       */
      "FREE": {
        "i": 2,
        "text": "Бесплатный",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "RfidPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "RfidPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По времени создания
       */
      "CREATED_AT": {
        "i": 1,
        "text": "По времени создания",
      },
      /**
       * По времени изменения
       */
      "CHANGED_AT": {
        "i": 2,
        "text": "По времени изменения",
      },
    },
  },
}